var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { UserSettingModel } from '../models/user-setting-model.interface';
let UserSettingServiceImpl = class UserSettingServiceImpl {
    constructor(_userSettingModel) {
        this._userSettingModel = _userSettingModel;
    }
    get userSetting() {
        return this._userSettingModel.userSetting;
    }
    updateUserSetting(userSetting) {
        this._userSettingModel.updateUserSetting(userSetting);
    }
    updateUserSettingRowHeight(rowHeight) {
        this._userSettingModel.updateRowHeightStyle(rowHeight);
    }
    updateUserSettingGoToWhere(goToWhere) {
        this._userSettingModel.updateGoToWhere(goToWhere);
    }
    subscribeUserSetting(callback) {
        return this._userSettingModel.subscribeUserSetting(callback);
    }
};
UserSettingServiceImpl = __decorate([
    injectable(),
    __param(0, inject(UserSettingModel)),
    __metadata("design:paramtypes", [typeof (_a = typeof UserSettingModel !== "undefined" && UserSettingModel) === "function" ? _a : Object])
], UserSettingServiceImpl);
export { UserSettingServiceImpl };
